import React, { useState, useEffect } from 'react';
import { getTeams } from './Teams';
import { fetchData, fetchAllPicksFromWeek } from './services/api';
import {
  getFirestore,
  getDocs,
  collection,
  query,
  where
} from 'firebase/firestore';

const WeeklyMatchup = ({ group, matchup, onPageChange }) => {
  const db = getFirestore();
  const user = JSON.parse(localStorage.getItem('profile'));

  const [week, setWeek] = useState(matchup?.week ?? 1);
  const [teams, setTeams] = useState([]);
  const [games, setGames] = useState([]);
  const [match, setMatch] = useState(null);
  const [myPicks, setMyPicks] = useState({});
  const [theirPicks, setTheirPicks] = useState({});
  const [points1, setPoints1] = useState(null);
  const [points2, setPoints2] = useState(null);
  const [bye, setBye] = useState(false);

  const alternates = ['Buccaneers', '49ers'];
  const white = ['Giants', 'Jets'];

  useEffect(() => {
    getTeams().then(setTeams).catch(console.error);
  }, []);

  useEffect(() => {
    const fetchMatchup = async () => {

        if(matchup != null){
            setBye(matchup.home === 'BYE' || matchup.away === 'BYE');
            setMatch(matchup);
            return;
        }
      if (!user?.Email || !group?.groupId) return;
      const week_matchup = await findPlayerMatchup(group.id, week, user.Email);
      setBye(week_matchup == null || week_matchup == null || week_matchup.home === 'BYE' || week_matchup.away === 'BYE');
      setMatch(week_matchup);
    };
    fetchMatchup();
  }, [group, week, user]);

  useEffect(() => {
    const loadData = async () => {
      if (!match) return;

      const allPicks = await fetchAllPicksFromWeek(week);
      const gameData = await fetchData(week, '2026');
      setGames(gameData.events);

      const my = allPicks.find(item => item.Email === match.home);
      const theirs = allPicks.find(item => item.Email === match.away);

      const myParsed = JSON.parse(my?.Picks || '{}');
      const theirParsed = JSON.parse(theirs?.Picks || '{}');

      setMyPicks(myParsed);
      setTheirPicks(theirParsed);

      let total1 = 0;
      let total2 = 0;

      gameData.events.forEach(game => {
        const winnerTeam = game.competitions[0].competitors.find(c => c.winner)?.team.name;

        const myPick = myParsed[game.id];
        if (myPick?.pick === winnerTeam) total1 += myPick?.val ?? 0;

        const theirPick = theirParsed[game.id];
        if (theirPick?.pick === winnerTeam) total2 += theirPick?.val ?? 0;
      });

      setPoints1(total1);
      setPoints2(total2);
    };

    loadData();
  }, [match]);

  const getDigit = (num, pos) => {
    if (num == null) return '';
    const str = num.toString().padStart(2, '0');
    return str[pos - 1] || '';
  };

  const getTeamColors = (team, pick) => {
    const base = team?.color;
    const alt = team?.alternateColor;
    const isAlt = alternates.includes(pick);
    return { color: isAlt ? alt : base, altColor: isAlt ? base : alt, isWhite: white.includes(pick) };
  };

  const changeWeek = delta => {
    setWeek(prev => Math.min(18, Math.max(1, prev + delta)));
  };

  const renderPickImage = photo => (
    <img style={photo ? {} : { width: '30px', height: '30px' }} src={photo || 'ex.png'} />
  );

  //if (!match) return null;

  const b2g = () => {
    onPageChange('groups');
}

  return (
    <div className="page">
    <div className="backToGroups" onClick={() => b2g()}>
                <span className="reverse">&#10142;</span> &nbsp; Back to Groups
            </div>
      <div className="group-matchup">
        <h1>{group?.name}</h1>
        <div className="group-matchup-header-buttons">
          {week > 1 && matchup == null && <div onClick={() => changeWeek(-1)}>Week {week - 1}</div>}
          <h2>Week {week}</h2>
          {week < 18 && matchup == null && <div onClick={() => changeWeek(1)}>Week {week + 1}</div>}
        </div>
        <br />
        <div className="group-matchup-header game">
          <div className="theirpicks pick">
            <div className="pick-val">
              <div className="pick-mascot">{match?.home}</div>
            </div>
            {!bye && (
              <div className="total-points">
                <span className="digitOne">{getDigit(points1, 1)}</span>
                <span className="digitTwo">{getDigit(points1, 2)}</span>
              </div>
            )}
          </div>
          <div className="x">VS</div>
          <div className="mypicks pick">
            {!bye && (
              <div className="total-points">
                <span className="digitOne">{getDigit(points2, 1)}</span>
                <span className="digitTwo">{getDigit(points2, 2)}</span>
              </div>
            )}
            <div className="pick-val">
              <div className="pick-mascot">{match?.away}</div>
            </div>
          </div>
        </div>

        {!bye && (
          <div>
            {games.length > 0 &&
              games.map((item, index) => {
                const comp = item.competitions[0].competitors;
                const winner = comp.find(c => c.winner)?.team || null;
                const date = new Date(item.date);

                const hasStarted = new Date() > date || item.competitions[0].status?.type?.description !== 'Scheduled';

                const hour12 = date.toLocaleTimeString([], { hour: 'numeric', hour12: true });
                const dayName = date.toLocaleDateString([], { weekday: 'long' });
                const currentDay = date.toDateString();
                const showDayHeader = index === 0 || new Date(games[index - 1].date).toDateString() !== currentDay;

                const p1 = myPicks[item.id];
                const p2 = theirPicks[item.id];

                const t1 = comp.find(c => c.team.name === p1?.pick)?.team;
                const { color: c1, isWhite: white1 } = getTeamColors(t1, p1?.pick);
                const correct1 = winner ? winner.name === t1?.name : null;

                const t2 = comp.find(c => c.team.name === p2?.pick)?.team;
                const { color: c2, isWhite: white2 } = getTeamColors(t2, p2?.pick);
                const correct2 = winner ? winner.name === t2?.name : null;

                const middle =
                  correct1 === true ? (
                    <div className="correctGuess"><img width="15" src="check.png" alt="Correct" /></div>
                  ) : correct1 === false ? (
                    <div></div>
                  ) : hour12;

                return (
                  <React.Fragment key={item.id}>
                    {showDayHeader && <div className="day-header">{dayName}</div>}
                    <div className={`game ${p1?.pick === p2?.pick || !hasStarted ? 'dull' : 'Highlighted'}`}>
                      <div className={`mypicks pick ${correct1 === true ? 'correct' : correct1 === false ? 'incorrect' : ''}`}>
                        <div className="pick-val">
                          <div className="pick-num" style={{ background: !hasStarted ? '#aaa' : `#${c1 || 'ccc'}` }}>
                            {!hasStarted ? '?' : p1?.val ?? 0}
                          </div>
                          <div className="pick-dash" style={{ background: !hasStarted ? '#aaa' : `#${c1 || 'ccc'}` }} />
                        </div>
                        <div className={`pick-image${white1 ? ' white-filter' : ''}`} style={{ background: !hasStarted ? '#aaa' : `#${c1 || 'ccc'}` }}>
                          {!hasStarted ? '?' : renderPickImage(teams[p1?.pick]?.photo)}
                        </div>
                      </div>
                      <div className="x">{middle === '12 AM' ? 'TBD' : middle}</div>
                      <div className={`theirpicks pick ${correct2 === true ? 'correct' : correct2 === false ? 'incorrect' : ''}`}>
                        <div className={`pick-image${white2 ? ' white-filter' : ''}`} style={{ background: !hasStarted ? '#aaa' : `#${c2 || 'ccc'}` }}>
                          {!hasStarted ? '?' : renderPickImage(teams[p2?.pick]?.photo)}
                        </div>
                        <div className="pick-val">
                          <div className="pick-dash" style={{ background: !hasStarted ? '#aaa' : `#${c2 || 'ccc'}` }} />
                          <div className="pick-num" style={{ background: !hasStarted ? '#aaa' : `#${c2 || 'ccc'}` }}>
                            {!hasStarted ? '?' : p2?.val ?? 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default WeeklyMatchup;

// Matchup fetcher
const findPlayerMatchup = async (groupId, week, playerEmailOrId) => {
    console.log(groupId);
  const db = getFirestore();
  const matchupsRef = collection(db, 'Groups', groupId, 'Matchups');

  const weekNumber = typeof week === 'string' ? parseInt(week, 10) : week;

  const homeQuery = query(matchupsRef, where('week', '==', weekNumber), where('home', '==', playerEmailOrId));
  const awayQuery = query(matchupsRef, where('week', '==', weekNumber), where('away', '==', playerEmailOrId));

  const [homeSnap, awaySnap] = await Promise.all([getDocs(homeQuery), getDocs(awayQuery)]);

  if (homeSnap.docs.length > 0) return homeSnap.docs[0].data();

  if (awaySnap.docs.length > 0) {
    const data = awaySnap.docs[0].data();
    return {
      ...data,
      home: data.away,
      away: data.home,
      homeScore: data.awayScore,
      awayScore: data.homeScore
    };
  }

  console.warn(`No matchup found for ${playerEmailOrId} in week ${weekNumber} of group ${groupId}`);
  return null;
};
